<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            v-model="settings.k0"
            type="number"
            label="K0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            v-model="settings.k1"
            type="number"
            label="K1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.k2"
            label="K2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.k3"
            label="K3"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.k4"
            label="K4"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.k5"
            label="K5"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.kconv"
            label="Kconv"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.limit1"
            label="Limit1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="1" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.limit2"
            label="Limit2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="2" class="pb-0">
          <v-text-field
            dense
            type="number"
            v-model="settings.lastDays"
            label="Last N Days"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2" class="pb-0">
          <v-text-field dense type="text" label="Last Build Date" disabled
                        v-model="settings.lastBuildDate"></v-text-field>
        </v-col>
        </v-row>
        <v-row>
        <v-col cols="12" class="pb-0 pt-6 d-flex flex-column flex-md-row" v-if="role == 'Admin' || managementRight">
          <RangeFilter
            :end="dateEnd"
            :start="dateStart"
            @getDates="getDates"
            :excludePeriod="excludePeriod"
            :defaultPeriod="defaultPeriod"
          />   
          <v-btn
            color="#3F51B5"
            class="mx-md-3 mt-md-0 mt-3"
            dark
            depressed
            max-width="228"
            @click="saveSettings"
          >
            Save and Build*
          </v-btn>
          <p style="padding-top: 14px;">* About 3-5 minutes</p>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="12" sm="6" md="4" class="pb-0">
          <v-autocomplete
            v-model="selectedCampaign"
            :items="campaigns"
            item-text="name"
            item-value="id"
            label="Campaigns"
            outlined
            dense
            class="text-body-2 text-capitalize mx-0 my-0 pr-0 pb-0"
          ></v-autocomplete>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" md="4" class="pb-0 d-flex justify-end">
          <v-btn
            class="mx-2"
            color="#3F51B5"
            dark
            depressed
            @click="openDialogComments"
            v-if="rankRight"
          >
            Comments
          </v-btn>
          <v-dialog v-model="dialogComments" max-width="600px">
            <v-card>
              <v-card-title class="headline grey lighten-2">
                Rank Comments
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="notationsHeaders"
                  :items="notations"
                  :items-per-page="5"
                  sort-by="data"
                  item-class="notations-table"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-spacer></v-spacer>
                        <template>
                          <v-btn
                            color="primary"
                            dark
                            class="mb-2"
                            @click="openDialogAddComment"
                          >
                            Add comment
                          </v-btn>
                        </template>
                      <v-dialog
                        v-model="dialogAddComment"
                        max-width="500px"
                        persistent
                      >
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            Add Comment
                          </v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-menu
                                  v-model="menuCommentData"
                                  close-on-content-click
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="dateComment"
                                      label="Date"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="dateComment"
                                    @input="showComment"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                              >
                                <v-textarea
                                  counter
                                  label="Comment"
                                  maxlength="255"
                                  v-model="commentText"
                                  outlined
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              text
                              @click="closeComment"
                            >
                              Close
                            </v-btn>
                            <v-btn
                              color="primary"
                              text
                              @click="saveComment"
                            >
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogEditComment" max-width="500px" persistent>
                        <v-card>
                          <v-card-title class="text-h5">Edit Comment</v-card-title>
                          <v-card-text>
                            <v-row>
                              <v-col
                                cols="12"
                              >
                                <v-textarea
                                  counter
                                  label="Comment"
                                  maxlength="255"
                                  v-model="commentText"
                                  outlined
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeEditComment">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="saveComment">OK</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogDeleteComment" max-width="500px" persistent>
                        <v-card>
                          <v-card-title class="text-h5">Confirmation</v-card-title>
                          <v-card-text>Are you sure you want to delete this comment?</v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDeleteComment">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteCommentConfirm">OK</v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.comment="{ item }">
                    <p class="text-left">{{item.comment}}</p>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editComment(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteComment(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogComments = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-card-title>
        <v-row class="px-2">
          <v-spacer></v-spacer>
          <v-col cols="7" md="6" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">
            <v-spacer></v-spacer>
            <vue-excel-xlsx
              :data="dataFilteredForExcel"
              :columns="columnsData"
              :filename="`Rank-${getCampaignName}`"
              :sheetname="`${createSheetName}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="!selectedCampaign"
                class="ml-auto mr-5 rounded-lg pa-0 ma-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
            </vue-excel-xlsx>
            <CustomColumns 
              :currentValue="value"
              :currentCustomHeader="customHeader"
              :currentHeaders="headers"
              :settingsName="settingsName"
              @getCustomData="getCustomData"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left"
              fab
              small     
              @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right"
              fab
              small
              @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
            loading-text="Loading... Please wait"
            :loading="loaded"
            :headers="selectedHeaders"
            :items="dataTable"
            item-key="id"
            fixed-header
            height="601px"
            class="elevation-0 mt-2 table-main-container"
            @click:row="rowClick"
          >
            <template v-for="header in selectedHeaders" v-slot:[`header.${header.value}`]>
              <v-tooltip v-if="headerTooltips[header.value]" top :key="header.value" max-width="700">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{header.text}}</span>
                </template>
                <span v-html="headerTooltips[header.value]"></span>
              </v-tooltip>
              <span v-else :key="header.value">{{header.text}}</span>
            </template>
            <template v-slot:item.r="{ item }">
              <a v-if="item.r>0" @click="getRankHistory(item)">{{ item.r }}</a>
              <span v-if="item.r==0">0</span>
            </template>
          </v-data-table>
          <v-dialog v-model="dialogHistory" max-width="600px">
            <v-card>
              <v-card-title class="d-flex flex-column align-start">
                <span>Rank History</span>
                <div class="d-flex">
                  <p class="text-subtitle-2 mt-1">Keyword: {{selectedKeyword ? selectedKeyword.text : ''}}</p>
                </div>
                <RangeFilter
                  class="mb-7 mt-1"
                  :end="dateEndHistory"
                  :start="dateStartHistory"
                  @getDates="getDatesHistory"
                  :excludePeriod="excludePeriod"
                  :defaultPeriod="defaultPeriodHistory"
                />
              </v-card-title>
              <v-card-text v-if="loadedHistory">
                <p class="mt-4 text-center">Loading... Please wait</p>
                <v-progress-linear
                  color="indigo"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-card-text>
              <v-card-text v-else>
                <apexchart :options="chartOptionsRankHistory" :series="seriesRankHistory"></apexchart>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="indigo white--text"
                  text
                  @click="closeHistory"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'

export default {
  components: {
    RangeFilter,
    CustomColumns,
    ExportExcel
  },
  data() {
    let self = this
    return {
      hideAnything: false,
      data: {},
      managementRight: false,
      rights: [],
      role: null,
      selectedCampaign: null,
      campaigns: [],
      loaded: false,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      headerTooltips: {
        va: "Volume in Gallons of product sold attributed to the keyword for all campaigns together",
        vc: 'Volume in Gallons of product sold attributed to the keyword inside the campaign',
        tc: 'Time (days) since last keyword order inside the campaign.</br.>(If there is no any orders, when we check a min Creation Date of the keyword)',
        ta: 'Time (days) since last keyword order for any campaign.</br>If there is no any orders, when we check a min Creation Date of the keyword)',
        tconv: 'Tconv_a=Time (days) since last conversion (any campaign)',
        cc: 'Number of conversions (google conversions, callrail calls, web inquiries etc) attributed</br>to the keyword inside the campaign',
        ca: '<p class="text-tooltip">Number of conversions (google conversions, callrail calls, web inquiries etc) attributed to the keyword for all campaigns together</p>',
        skwc: 'Spent last 90 days for this keyword, in dollars (current campaign)',
        skw: 'Spent last 90 days for this keyword, in dollars (any campaign)',
        savga: 'Spent last 90 days, average for 15 top active keywords, in dollars.</br>All campaigns',
        kc: 'Time coefficient. Campaign Level.</br>OLD:  Kc=(1/90) * (Skw90_c/ Savg90_a)</br>NEW: Kс=(1/(  90 * Q   + 1 )) * (Skw90_c/ Savg90)</p><p class="text-tooltip">Meaning: for 90 days without movement, function Gc will be reduced. Reduction of the rank occurs faster for more expensive keywords, and slower for less expensive keywords</p>',
        ka: 'Time coefficient. All Campaigns Level.</br>OLD:  Ka=(1/90)*(Skw90_a/Savg90_a)</br>NEW: Ka=(1/(  90 * Q  +1  )) * (Skw90_a/Savg90_a)</p><p class="text-tooltip">Meaning: for 90 days without movement, function Ga will be reduced. Reduction of the rank occurs faster for more expensive keywords, and slower for less expensive keywords.</p><p class="text-tooltip">‘в числителе расход на данный ключевик, в знаменателе средний расход по 15 активным ключевикам (сумма 15 расходов делить на 15), и потом всё умножаем на 1/90.</p><p class="text-tooltip">Чем меньше расход на данный ключевик по сравнению со средним активным, тем меньше Kа, и тем медленнее затухание. В частном случае skw90_a = savg90_a (то есть наш ключевик очень активный) Ka=1/90 = 0.011. Но обычно skw90_a ожидается намного меньше чем savg90_a, значит и Ка должно быть много меньше чем 0.011, а значит и затухание намного медленнее</p>',
        timeFromLastClick: 'Time since there was a click on this keyword (any campaign)',
        q1: 'Q1 - Bounce Rate Quality</br>Bounce rate BR определен так:<p class="text-tooltip">the percentage of visitors to a particular website who navigate away from the site after viewing only one page</p><p class="text-tooltip">Q1 = 1 - BR^2</p><p class="text-tooltip">Пример 1. В случае если BR для данного ключевика за 90 дней, при условии, что кол-во кликов больше 20, составляет 5%,  BR = 0.05.</p><p class="text-tooltip">То Q1 = 1 - 0.0025 = 0.99975</p><p class="text-tooltip">Пример 2. BR = 0.5. Q1 = 1 - 0.5*0.5 = 1 - 0.25 = 0.75</p>',
        q2: 'Q2 - Average Time Spent Quality</br>Q2 = AvgTimeOnSite/Max(AvgTimeonSite_allkeywords)',
        q3: 'Q3 - Average Relevancy Quality</br>Q3 =Нормированная длина вектора релевантности, вычисляем по формуле:</br>Q3=sqrt(generalrelevance*generalrelevance+industryrelevance</br>*industryrelevance+surfacerelevance*surfacerelevance+certificationrelevance</br>*certificationrelevance+productfeaturerelevance*productfeaturerelevance)  / 6.7082.</br>(Делим на максимальную величину вектора релевантности, чтобы величина Q3 всегда попадала в отрезок [0,1]',
        q: '<p class="text-tooltip">Q = Q1 * Q2 * Q3</p><p class="text-tooltip">If there are less than 10 clicks than Q=1</p><p class="text-tooltip">If Q1>0, Q2>0 but Q3=0 make Q3=1</p><p class="text-tooltip">Сначала мы определим коэффициет Q (от слова Quality ), показывающий качество данного ключевика. Q меняется в диапазоне от 0 до 1.</p><p class="text-tooltip">0 означает самое низкое качество, 1 - самое высокое качество.</p><p class="text-tooltip">Заметим, коэффициент Q не связан напрямую с ранком.</p><p class="text-tooltip">По умолчанию, Q для всех ключевиков считаем 1, то есть предполагаем что изначально все ключевики качественные.</p><p class="text-tooltip">Q данного ключевика может понижаться вследствие любого из 3х событий:</p> <ul><li>высокому bounce rate</li><li>низкий time on the site</li><li>низкая средняя релевантность конверсий при прослушке.</li></ul><p class="text-tooltip">Заметим что один ключевик приводит в общем случае к множеству конверсий, поэтому в случае отмеченных событий надо усреднять по конверсиям.</p><p class="text-tooltip">Объяснение. В случае Q=1 (отличное качество ключевика) характерный период затухания, как и раньше, около 90 дней, при условии средних затрат на ключевик (Skw90_a/Savg90_a=1).</p><p class="text-tooltip">При ухудшении качества ключевика Q падает от 1 к 0, этим уменьшая характерное время затухания. В хучшем случае, Q=0. Hапример если 100% звонков это спам, то знаменатель превращается в 1, и ранк начнёт резко падать (примерно в 2 раза за каждый день отсутсвия продаж)</p>',
        kt: 'Kt=K5 * TimeFromLastClick_a * Skw90_a/Savg90_a',
        bounceRate: 'Bounce rate BR определен так:<br>the percentage of visitors to a particular website who navigate away from the site after viewing only one page'
      },
      headers: [
        {text: 'Keyword', value: 'text', class: 'black--text'},
        {text: 'Match Type', value: 'matchType', class: 'black--text'},
        {text: 'Va', value: 'va', class: 'black--text'},
        {text: 'Vc', value: 'vc', class: 'black--text'},
        {text: 'Ta', value: 'ta', class: 'black--text'},
        {text: 'Tc', value: 'tc', class: 'black--text'},
        {text: 'Ca', value: 'ca', class: 'black--text'},
        {text: 'Cc', value: 'cc', class: 'black--text'},
        {text: 'Tconv_a', value: 'tconv', class: 'black--text'},
        {text: 'TimeFromLastClick_a', value: 'timeFromLastClick', class: 'black--text'},
        {text: 'Savg_a', value: 'savga', class: 'black--text'},
        {text: 'Skw_a', value: 'skw', class: 'black--text'},
        {text: 'Skw_c', value: 'skwc', class: 'black--text'},
        {text: 'Ka', value: 'ka', class: 'black--text'},
        {text: 'Kc', value: 'kc', class: 'black--text'},
        {text: 'Kt', value: 'kt', class: 'black--text'},
        {text: 'Ga(t)', value: 'gat', class: 'black--text'},
        {text: 'Gc(t)', value: 'gct', class: 'black--text'},
        {text: 'Gconv(t)', value: 'gconvt', class: 'black--text'},
        {text: 'Bounce Rate', value: 'bounceRate', class: 'black--text'},
        {text: 'Avg Session Duration', value: 'avgSessionDuration', class: 'black--text'},
        {text: 'Clicks', value: 'clicks', class: 'black--text'},
        {text: 'Q1', value: 'q1', class: 'black--text'},
        {text: 'Q2', value: 'q2', class: 'black--text'},
        {text: 'Q3', value: 'q3', class: 'black--text'},
        {text: 'Q', value: 'q', class: 'black--text'},
        {text: 'R', value: 'r', class: 'black--text'},
      ],
      value: [
        {text: 'Keyword', value: 'text', class: 'black--text'},
        {text: 'Match Type', value: 'matchType', class: 'black--text'},
        {text: 'Va', value: 'va', class: 'black--text'},
        {text: 'Vc', value: 'vc', class: 'black--text'},
        {text: 'Ta', value: 'ta', class: 'black--text'},
        {text: 'Tc', value: 'tc', class: 'black--text'},
        {text: 'Ca', value: 'ca', class: 'black--text'},
        {text: 'Cc', value: 'cc', class: 'black--text'},
        {text: 'Tconv_a', value: 'tconv', class: 'black--text'},
        {text: 'TimeFromLastClick_a', value: 'timeFromLastClick', class: 'black--text'},
        {text: 'Savg_a', value: 'savga', class: 'black--text'},
        {text: 'Skw_a', value: 'skw', class: 'black--text'},
        {text: 'Skw_c', value: 'skwc', class: 'black--text'},
        {text: 'Ka', value: 'ka', class: 'black--text'},
        {text: 'Kc', value: 'kc', class: 'black--text'},
        {text: 'Kt', value: 'kt', class: 'black--text'},
        {text: 'Ga(t)', value: 'gat', class: 'black--text'},
        {text: 'Gc(t)', value: 'gct', class: 'black--text'},
        {text: 'Gconv(t)', value: 'gconvt', class: 'black--text'},
        {text: 'Bounce Rate', value: 'bounceRate', class: 'black--text'},
        {text: 'Avg Session Duration', value: 'avgSessionDuration', class: 'black--text'},
        {text: 'Clicks', value: 'clicks', class: 'black--text'},
        {text: 'Q1', value: 'q1', class: 'black--text'},
        {text: 'Q2', value: 'q2', class: 'black--text'},
        {text: 'Q3', value: 'q3', class: 'black--text'},
        {text: 'Q', value: 'q', class: 'black--text'},
        {text: 'R', value: 'r', class: 'black--text'},
      ],
      customHeader: ['text', 'matchType', 'va', 'vc', 'ta', 'tc', 'ca', 'cc', 'tconv', 'timeFromLastClick',
                     'savga', 'skw', 'skwc', 'ka', 'kc', 'gat', 'gct', 'gconvt', 'kt',
                     'bounceRate','avgSessionDuration','clicks','q1','q2', 'q3', 'q', 'r'],
      selectedHeaders: [],
      settingsName: 'Rank',
      columnsData: [],
      dataTable: [],
      settings: {},
      dialogHistory: false,
      loadedHistory: false,
      dateEndHistory: new Date().toISOString().substr(0, 10),
      dateStartHistory: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      defaultPeriodHistory: 2,
      selectedKeyword: null,
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      notationsHeaders: [
        {text: 'Date', value: 'data', class: 'black--text'}, 
        {text: 'Comment', value: 'comment', class: 'black--text'},
        { text: 'Actions', value: 'actions', class: 'black--text', sortable: false }
        ],
      notations: [],
      dialogComments: false,
      dialogAddComment: false,
      dialogEditComment: false,
      dialogDeleteComment: false,
      menuCommentData: false,
      dateComment: null,
      commentText: null,
      commentId: null,
      isExistComment: false,
      seriesRankHistory: [
          {
            name: 'Rank',
            type: 'line',
            data: []
          },
          {
            name: `Sales`,
            type: 'scatter',   
            data: []
          },
          {
            name: `Sales`,
            type: 'scatter',   
            data: []
          },
          {
            name: `Notation`,
            type: 'scatter',   
            data: []
          }
      ],
      chartOptionsRankHistory: {
            chart: {
              height: 350,
              type: 'line',
              id: 'chartRankHistory',
            },
            offsetX: 0,
            offsetY: 0,
            stroke: {
              curve: 'smooth',
              width: [2,2]
            },
            fill: {
              type:'solid',
            },
            colors: ['#6372c3'],
            markers: {
              size: [4, 4],
              colors: ['#6372c3'],
              strokeWidth: 1,
            },
            annotations: {
              xaxis: [
                {
                  x: new Date('13 Mar 2021').getTime(),
                  borderColor: '#775DD0',
                  fillColor: '#c2c2c2',
                  label: {
                    text: null
                  }
                }
              ]
            },
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false
              },
              y: [],
              fixed: {
                  enabled: false,
                  position: 'topRight',
                  offsetX: 0,
                  offsetY: 0,
              },
              custom: function(opts) {
                const name =
                  opts.ctx.w.config.series[opts.seriesIndex].name

                const color = 
                  opts.ctx.w.config.series[opts.seriesIndex].data[
                      opts.dataPointIndex
                    ].fillColor

                const date = 
                  opts.ctx.w.config.series[opts.seriesIndex].data[
                      opts.dataPointIndex].x

                const value = opts.series[opts.seriesIndex][opts.dataPointIndex]

                const data = opts.ctx.w.config.series[opts.seriesIndex].data

                const selectedCampaign = data.reduce((acc, e) => (e.id == self.selectedCampaign) ? [...acc, e] : acc, [])
                const notSelectedCampaign = data.reduce((acc, e) => (e.id !== +self.selectedCampaign) ? [...acc, e] : acc, [])

                const salesSelectedCampaign = self.groupsByDate(selectedCampaign).find(e => e.date === date)?.value.length
                const salesNotSelectedCampaign = self.groupsByDate(notSelectedCampaign).find(e => e.date === date)?.value.length
                
                const gallonsNotSelectedCampaigns = self.groupsByDate(notSelectedCampaign).find(e => e.date === date)?.value.reduce((acc, e) => acc + e.gallons, 0)
                const gallonsSelectedCampaign = self.groupsByDate(selectedCampaign).find(e => e.date === date)?.value.reduce((acc, e) => acc + e.gallons, 0)
                
                const countSelectedCampaignSales = self.groupsByDate(selectedCampaign).find(e => e.date === date)
                const selectedCampaignName = countSelectedCampaignSales?.value.map(e => e.description)
                const countNotSelectedCampaignSales = self.groupsByDate(notSelectedCampaign).find(e => e.date === date)
                const notSelectedCampaignsNames = countNotSelectedCampaignSales?.value.map(e => e.description)

                const notation = self.groupsByDate(data).find(e => e.date === date)?.value.map(e => e.comment)

                let content
                if (opts.seriesIndex === 0) {
                  content = `<b>${name}</b>${value}`
                }
                if (opts.seriesIndex === 1) {
                  content = `<b>${selectedCampaignName}</b><br/><b>Sales:</b> ${salesSelectedCampaign}<br/><b>Gallons: </b>${gallonsSelectedCampaign}`
                }
                if (opts.seriesIndex === 2) {
                  content = `<b>All sales: </b> ${salesNotSelectedCampaign} <br/>
                                                                        <b>All gallons: </b>${gallonsNotSelectedCampaigns}<br/> 
                                                                        <b>Campaigns: </b>${notSelectedCampaignsNames}`
                }
                if (opts.seriesIndex === 3) {
                  content = `<div class="notation">${notation}</div>`
                }

                return `<div>
                  <span class="px-5" style="background-color:${color}20; display:block"><b>${date.slice(0, 10)}</b></span>   
                    <span class="px-5 my-1" style="display:block">
                      ${content}</span>         
                </div>`
              }
            },
            legend: {
              show: false
            },
            xaxis: {
              type: 'datetime',
              offsetX: 0,
              offsetY: 0,
              axisBorder: {
                  show: true,
                  color: '#78909C',
                  height: 1,
                  width: '100%',
                  offsetX: 0,
                  offsetY: 0
              },
              axisTicks: {
                  show: true,
                  borderType: 'solid',
                  color: '#78909C',
                  height: 1,
                  offsetX: 0,
                  offsetY: 0
              },
              labels: {
                show: true,
                rotate: -45,
                hideOverlappingLabels: true,
                formatter: function(value, timestamp, opts) {
                  return opts.dateFormatter(new Date(timestamp), 'MM/dd/yyyy')
                }
              }
            },
            yaxis: {
              type: 'numeric',
              title: 'Rank',
              min: 0,
              forceNiceScale: true,
              labels: {
                formatter: (value) => {
                  return value
                }
              },
            },
            grid: {
              show: true,
              strokeDashArray: 1,
              padding: {
                top: 0,
                right: 10,
                bottom: 0,
                left: 10
              }, 
              xaxis: {
                lines: {
                  show: true
                }
              },
              yaxis: {
                lines: {
                  show: true
                }
              },
            },

          },
    }
  },
  watch: {
    selectedCampaign: function (val) {
      this.fetchCampaign(val)
    },
    hoverOnTable(){
      this.showScrollingArrows()
    },
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    },
  },
  created() {
    window.addEventListener("resize", this.showScrollingArrows)

    this.selectedHeaders = this.value
    this.getHeaderForExcel()
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    axios
      .get('/users/me')
      .then(response => {
        this.role = response.data.data.role
        this.rights = response.data.data.rights
        this.managementRight = (this.rights == {}) ? false : this.rights.includes('rank')
      })

    axios
        .get('/settings-rank')
        .then(response => (this.settings = response.data))

    axios
        .get('/campaigns-rank')
        .then(response => (this.campaigns = response.data.data))

      let userName = localStorage.getItem('username')
      let settings = this.settingsName
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
      if (localStorage.getItem(`${userName}.${clientId}.${settings}`)) {
      
       try {

        let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}`))
        this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))
        
        const parsed = JSON.stringify(this.value)
        localStorage.setItem(`${userName}.${clientId}.${settings}`, parsed)

        this.customHeader = this.value.map(e => e.value)

        this.getHeaderForExcel()
       } catch(e) {
         console.log("")
      }
    }

    this.showScrollingArrows()
  },
  computed: {
    rankRight(){
      return (this.rights == {}) ? false : this.rights.includes('rank')
    },
    getCampaignName(){
      return (this.selectedCampaign) 
      ? this.campaigns.find(e => e.id == this.selectedCampaign).name
      : ''
    },
    dataFilteredForExcel(){
      let data = JSON.parse(JSON.stringify(this.dataTable))

      return data
    },
    createSheetName(){
      let name = `${this.settingsName}-${this.getCampaignName}`
      if (name.length > 30) name = name.substr(0, 30)
      name = name.replace(/(\\|\/)/g, '-')
      return name
    },
  },
  methods: {
    groupsByDate(data) { 
      return this._.chain(data)
          .groupBy("x")
          .map((value, key) => ({date: key, value: value}))
          .value()
    },
    getCustomData({customHeader, value, selectedHeaders}){
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders

      this.getHeaderForExcel()
    },
    getHeaderForExcel(){
      this.columnsData = this.selectedHeaders.map(e => {
        const obj = {}
          if (e.value !== "actions") {
            obj.label = e.text
            obj.field = e.value
          }
          if (e.value === "totalCost") {
            obj.label = `${e.text},$`
            obj.field = e.value
          }
          return obj
      }).filter(value => Object.keys(value).length !== 0)
    },
    scrollingRight(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft(){
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left')
      const btnRight = document.querySelector('.btn-right')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows(){
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right')
      const btnLeft = document.querySelector('.btn-left')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    getDatesHistory(dates) {
      this.dateStartHistory = dates.dateStart
      this.dateEndHistory = dates.dateEnd
      this.getRankHistory(this.selectedKeyword)
    },
    closeHistory() {
      this.dialogHistory = false
      this.loadedHistory = false
    },
    getRankHistory(item) {
      this.selectedKeyword = item
      if (sessionStorage.getItem('dateStart')) {
        this.dateStartHistory = sessionStorage.getItem('dateStart')
      }
      if (sessionStorage.getItem('dateEnd')) {
        this.dateEndHistory = sessionStorage.getItem('dateEnd')
      }
      this.getNotations()
      this.dialogHistory = true
      this.loadedHistory = true

      axios
          .get('/rank-history/' + this.selectedKeyword.keywordId + '/' + this.selectedKeyword.campaignId + '/' + this.dateStartHistory + '/' + this.dateEndHistory)
          .then(response => {

            response.data.sales.sort((a, b) => new Date(a.saleDate) - new Date(b.saleDate))
                        this.seriesRankHistory[0].data = response.data.data.map(el => {
                return {x: el.createdDate.split(' ')[0] + ' GMT', y: el.rank.toFixed(2), fillColor: '#6372c3'}
            })

            this.seriesRankHistory[1].data = response.data.sales
              .filter(e => e.campaignId == this.selectedCampaign)
              .map(el => {
                  return {
                    description: el.campaignName,
                    id: el.campaignId,
                    x: el.saleDate.split(' ')[0] + ' GMT', 
                    y: 3, 
                    fillColor: '#1ca539',
                    gallons: el.gallons
                  }
              })

            this.seriesRankHistory[2].data = response.data.sales
              .filter(e => e.campaignId != this.selectedCampaign)
              .map(el => {
                  return {
                    description: el.campaignName,
                    id: el.campaignId,
                    x: el.saleDate.split(' ')[0] + ' GMT', 
                    y: 1, 
                    fillColor: '#f79e20',
                    gallons: el.gallons
                  }
                })

          this.chartOptionsRankHistory.annotations.xaxis = 
            [...this.seriesRankHistory[1].data,
            ...this.seriesRankHistory[2].data,
            ...this.seriesRankHistory[3].data]
            .map(e => {
              return {x: new Date(e.x).getTime(), borderColor: e.fillColor, label: {text: ''}}
            })

            let maxRankHistory = Math.ceil(Math.max(...this.seriesRankHistory[0].data.map(e => +e.y)))
            this.chartOptionsRankHistory.yaxis.max = (maxRankHistory < 11) ? maxRankHistory : Math.ceil(maxRankHistory / 10) * 10
            this.chartOptionsRankHistory.yaxis.tickAmount = (maxRankHistory < 6) ? maxRankHistory : 5

            this.loadedHistory = false
          }
        )
    },
    getNotations(){
      axios
      .get('rank-notation')
      .then(response => {
        this.notations = response.data
        this.notations.map(e => e.data = e.data.substr(0, 10))

        this.seriesRankHistory[3].data = this.notations.map(el => {
          return {
            id: el.id,
            x: el.data + ' GMT',
            y: 0, 
            fillColor: '#d87691',
            comment: el.comment
          }
        })
      })
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
    },
    saveSettings() {
      axios({
        url: '/settings-rank',
        method: 'post',
        timeout: 5000,
        data: this.settings
      })
    },
    fetchCampaign(val) {
      this.loaded = true
      axios
          .get('/campaign-rank/' + val)
          .then(response => (this.dataTable = response.data.data))

      this.loaded = false
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    openDialogComments(){
      this.getNotations()
      this.dialogComments = true
    },
    openDialogAddComment(){
      this.dialogAddComment = true
    },
    editComment(item) {
      this.commentText = item.comment
      this.commentId = item.id
      this.dateComment = item.data
      this.dialogEditComment = true
    },
    closeEditComment(){
      this.dialogEditComment = false
      this.dateComment = null
      this.commentText = null
      this.commentId = null
    },
    deleteComment(item) {
      this.commentText = item.comment
      this.commentId = item.id
      this.dateComment = item.data
      this.dialogDeleteComment = true
    },

    deleteCommentConfirm () {
      axios
        .delete('/rank-notation/' + this.commentId)
        .then((response) => {
          this.notations = response.data
          this.notations.map(e => e.data = e.data.substr(0, 10))

          this.seriesRankHistory[3].data = this.notations.map(el => {
            return {
              id: el.id,
              x: el.data + ' GMT',
              y: 0, 
              fillColor: '#d87691',
              comment: el.comment
            }
          })

          this.updateSeries()
          this.updateOptions()

        })

      this.closeDeleteComment()
    },
    closeDeleteComment(){
      this.dateComment = null
      this.commentText = null
      this.commentId = null
      this.dialogDeleteComment = false
    },
    showComment(){
      let date = new Date(this.dateComment)
      let month = String(date.getMonth() + 1)
      let day = String(date.getDate())
      const year = String(date.getFullYear())
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      date = `${month}/${day}/${year}`

      this.isExistComment = this.notations.some(e => e.data == date)
      this.commentText = this.isExistComment ? this.notations.find(e => e.data == date).comment : null
      this.commentId = this.isExistComment ? this.notations.find(e => e.data == date).id : null

      this.menuCommentData = false
    },
    closeComment(){
      this.dateComment = null
      this.commentText = null
      this.dialogAddComment = false
    },
    saveComment(){
      axios
        .post('/rank-notation', {
          id: this.commentId,
          date: this.dateComment,
          comment: this.commentText
        }).then((response) => {
          this.notations = response.data
          this.notations.map(e => e.data = e.data.substr(0, 10))

          this.seriesRankHistory[3].data = this.notations.map(el => {
            return {
              id: el.id,
              x: el.data + ' GMT',
              y: 0, 
              fillColor: '#d87691',
              comment: el.comment
            }
          })
          
          this.updateSeries()
          this.updateOptions()

          this.dialogAddComment = false
          this.dialogEditComment = false
          this.dateComment = null
          this.commentText = null
          this.commentId = null
        })    
    },
    updateSeries() {
      this.seriesRankHistory = [
        this.seriesRankHistory[0], 
        this.seriesRankHistory[1], 
        this.seriesRankHistory[2], 
        this.seriesRankHistory[3]
      ]
    },
    updateOptions(){
      this.chartOptionsRankHistory = {...this.chartOptionsRankHistory, ...{
        annotations: {
          xaxis: this.chartOptionsRankHistory.annotations.xaxis = 
            [...this.seriesRankHistory[1].data,
            ...this.seriesRankHistory[2].data,
            ...this.seriesRankHistory[3].data]
            .map(e => {
              return {x: new Date(e.x).getTime(), borderColor: e.fillColor, label: {text: ''}}
            })
        } 
      }}
    },
  }
}
</script>

<style>
  .scroll-btn {
    visibility: visible;
    position: absolute;
    z-index: 1000;
    background-color: #ffffff;
    color: #757575 !important;
    line-height: .9;
    height: 34px;
    width: 34px
  }
  .btn-right {
    right: 0px;
    top: 65px;
  }
  .btn-left {
    left: 0px;
    top: 65px;  
  }
  .scroll-btn:focus, .scroll-btn:hover {
    color: #388aed !important;
  }
  .scroll-btn:focus::before {
    opacity: 0 !important;
  }
  .scroll-btn .btn-right:not(:focus) {
    box-shadow: 0 3px 9px rgba(0,0,0,0.4),0 -1px 4px rgba(0,0,0,0.2);
    border: none;
  }
  .apexcharts-tooltip {
    max-width: 70% !important;
  }
  .notation {
    white-space: pre-wrap !important;
  }
  .notations-table {
      color: red !important;
  }
  .text-tooltip {
    text-indent: 20px !important;
    text-align: justify !important;
  }
</style>